import { useEffect, useRef, useState } from "react";
import { enqueueSnackbar } from "@powerdiary/components-library/lib/components/Snackbar";
import { Link, Typography, useMediaQuery, useTheme } from "@mui/material";

export default function useUrlOpener() {
    const [zoomAppClickCount, setZoomAppClickCount] = useState(0);
    const zoomClickResetTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    useEffect(() => {
        return () => {
            if (zoomClickResetTimeoutRef.current) {
                clearTimeout(zoomClickResetTimeoutRef.current);
            }
        };
    }, []);

    const openUrlInCurrentTab = (url: string) => {
        if (isMobile) {
            setZoomAppClickCount((prevCount) => prevCount + 1);

            if (zoomClickResetTimeoutRef.current) {
                clearTimeout(zoomClickResetTimeoutRef.current);
                zoomClickResetTimeoutRef.current = null;
            }

            zoomClickResetTimeoutRef.current = setTimeout(() => {
                setZoomAppClickCount((prevCount) => prevCount - 1);
                zoomClickResetTimeoutRef.current = null;
            }, 10000);

            if (zoomAppClickCount > 0) {
                enqueueSnackbar(
                    <Typography variant="body2">
                        Please ensure the Zoom desktop app is installed on your device. You can
                        <Link variant="medium" href="https://zoom.us/download" target="_blank">
                            {` `}download the Zoom Desktop App here{` `}
                        </Link>
                        or start the session directly in your browser.`
                    </Typography>,
                    {
                        variant: "error",
                        alertTitle: "Error registering",
                    }
                );
            }
        }

        if (url) window.location.href = url;
    };

    const openUrlInNewTab = (url: string) => {
        if (url) window.open(url, "_blank", "noopener,noreferrer");
    };

    return {
        openUrlInCurrentTab,
        openUrlInNewTab,
    };
}
